import Vue from 'vue'
import Router from 'vue-router'

import routes from './route'

Vue.use(Router)

//解决重复点击路由报错问题
const origin_push = Router.prototype.push
const origin_replace = Router.prototype.replace

Router.prototype.push = function (location, onComplete, onAbort) {
    if (onComplete == null && onAbort == null) {
        return origin_push.call(this, location, onComplete, onAbort).catch(() => {
        })
    } else {
        origin_push.call(this, location, onComplete, onAbort)
    }
}

Router.prototype.replace = function (location, onComplete, onAbort) {
    if (onComplete == null && onAbort == null) {
        return origin_replace.call(this, location, onComplete, onAbort).catch(() => {
        })
    } else {
        origin_push.call(this, location, onComplete, onAbort)
    }
}

const router = new Router({
    routes: routes
})


export default router


